import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BusinessDomainService } from './business-domain.service';

@Component({
  selector: 'app-businessdomain-icon',
  templateUrl: './business-domain-icon.component.html',
  styles: ['.businessdomain-icon { margin: 0; vertical-align: middle; }']
})
export class BusinessDomainIconComponent implements OnChanges {
  @Input() businessdomain: string;
  @Input() size: string;

  public title: string = '';

  constructor(private businessdomainService: BusinessDomainService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selected = this.businessdomainService.getBusinessDomainByValue(this.businessdomain);
    this.title = 'task.businessDomain.' + selected.value;
  }

}
